export class eaeas {
    solution() {
        return 'eaeas'
    }

    site() {
        return 'https://www.processor.com.br/ea-eas'
    }

    logotipo() {
        return require('./assets/logotipos/logo_eaeas.svg').default
    }
    titulo() {
        return <>Transforme a <b>gestão de licenças de software</b> da organização com Softwares.com.br</>
    }

    chamada() {
        return <>Consolida as licenças em uma única plataforma, permitindo um licenciamento mais eficiente e uma visão do uso de software para a gestão de contratos corporativos Microsoft em toda a organização.</>
    }

    image() {
        return require('./assets/imgs/imagem_eaeas.png').default
    }

    detalhes() {
        return <>
            <h2>Licenciamento de software inteligente, econômico e eficiente</h2>
            <p>Com o know-how de implantação da Processor e uma equipe de especialistas, as organizações consolidam suas licenças em uma única plataforma, permitindo um licenciamento mais eficiente e uma visão consolidada do uso de software em toda a organização. Isso proporciona maior controle, compliance e agilidade para lidar com as demandas de software em constante evolução.</p>
            <h3>Por que escolher Softwares.com.br</h3>
            <div className="pq-gtm">
                <div className="tela">
                    <img src={require('./assets/telas/tela_eaeas.png').default} />
                </div>
                <ul>
                    <li><b>Licenciamento simplificado:</b> Gerencie e monitore suas licenças de forma centralizada, simplificando a conformidade e facilitando as atualizações.</li>
                    <li><b>Flexibilidade e escalabilidade:</b> Adicione ou remova produtos e serviços à medida que as necessidades da organização evoluem.</li>
                    <li><b>Custos previsíveis:</b> Com um contrato de licença de vários anos, controle gastos com software.</li>
                    <li><b>Padronização e conformidade:</b> Padronize a infraestrutura de software em toda a organização, garantindo conformidade e consistência em todas as operações.</li>
                    <li><b>Suporte técnico avançado:</b> Conte com suporte técnico especializado, garantindo às equipes assistência sempre que necessário e mantendo os sistemas em funcionamento sem interrupções.</li>
                </ul>
            </div>
            <div className="box">Softwares.com.br é uma solução completa para a <b>gestão de licenças de software</b>, proporcionando maior eficiência, controle e agilidade para a organização.</div>
            <h3>Não perca tempo!</h3>
            <p>Entre em contato conosco hoje mesmo e descubra como Softwares.com.br pode transformar a gestão de licenças de software da organização.</p>
        </>
    }
}
export default eaeas;